// For first party app ids, please ensure the values map to the corresponding ids in FirstPartyWorkloadIds.ts without the "Shell" prefix.
// For example, "ShellWordOnline" => "WordOnline"
export var HubTileID = {
    home: '5099F2E5-AD99-4BF2-BF82-DF525FFD0BE2',
    create: '83d3f491-b586-4266-8738-89776471bf21',
    mycontent: 'F57D5D29-4967-495C-A648-F7AB66BF8572',
    chat: '94545115-8c89-4a9f-8272-1ccee5c28b41',
    catchUp: 'afbd56a5-e111-4ee6-b6b6-17afaf3918e0',
    collect: '3bba1fd4-9a60-4680-b81a-30ae6c01bad9',
    peopleAIHub: '7f9efbbf-80cb-4c3b-95ee-7d73db7a43fe',
    prepare: '198ef507-e89b-1d49-aa86-46761cd74025',
    news: '5ce5bc5c-16c9-4a29-9ff4-df396193361d',
    browse: 'ed0250ea-28ed-4862-814b-339fe6a547c4',
    orion: '099317ab-9a66-4a75-868c-dc2263ce2eb9',
    intents: '2CC62124-219E-4777-9A92-00CDE9062859',
    feed: '261d33d6-15ba-4e1d-b298-8096960fab40',
    appgallery: '26706956-2AAE-4A22-8960-09B98C35B28C',
    alps: '4fbe3a87-55c7-45f6-a518-462f40fd25a0',
    aiHubSample: '3476f2d2-8249-4f78-aa10-577662aeca5b',
    assist: '8482aa08-12f4-4c5d-9a23-e48a4b553fe8',
    automate: 'db3d8604-0656-46c3-801b-1a0c33552e3e',
    outlook: 'Mail',
    onedrive: 'Documents',
    teams: 'SkypeTeams',
    word: 'WordOnline',
    excel: 'ExcelOnline',
    powerpoint: 'PowerPointOnline',
    onenote: 'OneNoteOnline',
    sway: 'Sway',
    forms: 'OfficeForms',
    admin: 'Admin',
    visio: 'VisioOnline',
    stream: 'MicrosoftStream',
    todo: 'ToDo',
    familysafety: 'FamilySafety',
    calendar: 'Calendar',
    skype: 'Skype',
    people: 'People',
    powerautomate: 'LogicFlows',
    clipchamp: 'Clipchamp',
    lists: 'Lists',
    yammer: 'Yammer',
    powerbi: 'PowerBIv2',
    bing: 'Bing',
    msn: 'MSN',
    privacy: 'Privacy',
    rewards: 'Rewards',
    whiteboard: 'Whiteboard',
    defender: 'Defender',
    copilotMos: 'd870f6cd-4aa5-4d42-9626-ab690c041429',
    copilotExternal: 'CopilotExternal',
    copilotCmc: 'c33fcfa5-dec3-4511-bb3b-7b6cf1d804ed',
};
//# sourceMappingURL=HubTileID.js.map